// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2tyz5","radioRow":"SimpleQuestionBuilderModal_radioRow__1wNJP"};